<div class="conatiner-fluid">
    <div class="row">
        <div class="col-2">
            <h2>Reports</h2>
        </div>
        <!-- <button (click)="FollowUpCustDetials()">test</button> -->
        <div class="col-10">
            <div class="card" style="padding: 10px; margin-top: 50px;">
                <div class="form-row">
                    <!-- <div class="form-group col-12">
                        <label for="">BANK NAME</label>
                        <select [(ngModel)]="bankid" class="form-control"  (change)="fetchuser_1()">
                            <option *ngFor="let item of bankList" [value]="item._id">{{item.bank_name}}</option>
                        </select>
                        <p style="color: red;font-size: small;" *ngIf="error_msg !== ''">* You Don't Have a access. Please Contact your Admin</p>
                    </div> -->
                    <div class="form-group col-12">
                        <label for="">POTFOLIO NAME</label>
                        <select [(ngModel)]="portfolioid" class="form-control">
                            <option [value]="" >select portfolio</option>
                            <option *ngFor="let item of portfolioList" [value]="item._id">{{item.portfolio_type}}</option>
                        </select>
                    </div>
                    <!-- <div class="form-group col-12">
                        <label for="">BUCKET ID</label>
                        <select [(ngModel)]="bucketid" class="form-control">
                            <option *ngFor="let item of bucketList" [value]="item._id">{{item.bucket_id}}</option>
                        </select>
                    </div> -->

                </div>
            </div>
        </div>
    </div>
    <div class="row" style="text-align: right;">
        <div class="col-12" style="text-align: right;">
            <button class="btn btn-sm btn-dark mr-1 mt-1 mb-1" (click)="search()">Search</button>
        </div>
    </div>
</div>
<div class="container-fluid" *ngIf="!searchLoaded">
    <div class="row" style="text-align: center;">
        <div class="col-12" style="text-align: center;">
            <div class="card" style="padding: 10px;">
                <h3>
                   --- Please Select Bank, Potfolio & Bucket ---
                </h3>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid" *ngIf="searchLoaded">
    <div class="row">
        <div class="col-12">
            <mat-tab-group  (selectedTabChange)="yourFn($event)">

                <mat-tab label="PTP Reports">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportPTPreport()">EXPORT</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2">
                                <label>Start Date</label>
                            <input type="date" class="form-control" placeholder="Text Search" [(ngModel)]="ptp_start_date">
                            </div>
                            <div class="col-md-2">
                                <label>End Date</label>
                            <input type="date" class="form-control" placeholder="Text Search" [(ngModel)]="ptp_end_date">
                            </div>
                            <div class="col-md-2">
                                <label>Select Agent</label>
                                <select [(ngModel)]="agent_search" class="form-control" >
                                    <option *ngFor="let item of user_list" [value]="item.email_id">{{item.name}}</option>
                                </select>
                            </div>
                            <div  class="col-md-4">
                                <label>Action</label><br>
                                <button class="btn btn-sm btn-dark mb-1" (click)="datesearch()">
                                    Search
                                </button>
                                <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="clear()">
                                    Clear
                                </button>
                            </div>
                        </div>

                        <!-- {{FollowUpList |json}} -->
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">
                            <thead>
                                <tr>
                                    <th>S.No </th>
                                    <th>bank</th>
                                    <th>Agent</th>
                                    <th>Fint No</th>
                                    <th>Customer Name</th>
                                    <th>passport no</th>
                                    <th>CID</th>
                                    <th>acc number</th>
                                    <th class="sortable" (click)="sort7('ptp_amount')">PTP AMOUNT <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                   <th class="sortable" (click)="sort7('ptp_status')">PTP DATE <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                    <th class="sortable" (click)="sort7('log_date')">Logged Date and Time <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of FollowUpList ; let i = index;">
                                    <td>{{i+1}}</td>
                                    <td>{{item?.bank_name}}</td>
                                    <td>{{item?.agent_name}}</td>
                                    <td>{{item?.finterstal_id}}</td>
                                    <td>{{item?.customer_name}}</td>
                                    <td>{{item?.passport_no}}</td>
                                    <td>{{item?.cif}}</td>
                                    <td>{{item?.acc_no}}</td>
                                    <td>{{item?.ptp_amount | number: '2.'}}</td>
                                    <td>{{item?.ptp_date | date}}</td>
                                    <td>{{item?.log_date}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>
                <mat-tab label="Payments Reports">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportPaymentsreport()">EXPORT</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2">
                                <label>Start Date</label>
                            <input type="date" class="form-control"  [(ngModel)]="payment_start_date">
                            </div>
                            <div class="col-md-2">
                                <label>End Date</label>
                                <input type="date" class="form-control"  [(ngModel)]="payment_end_date">
                            </div>
                            <div class="col-md-2">
                                <label>Agent Name</label>
                                <select [(ngModel)]="payment_text_search" class="form-control" >
                                    <option *ngFor="let item of user_list" [value]="item.email_id">{{item.name}}</option>
                                </select>
                            </div>
                            <div  class="col-md-4">
                                <label>Action</label><br>
                                <button class="btn btn-sm btn-dark mb-1" (click)="payment_datesearch()">
                                    Search
                                </button>
                                <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="payment_clear()">
                                    Clear
                                </button>
                            </div>
                        </div>
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>bank</th>
                                    <th>Fint</th>
                                    <th>Agent Name</th>
                                    <th>customer name</th>
                                    <th>passport no</th>
                                    <th>CID</th>
                                    <th>acc number</th>
                                    <th class="sortable" (click)="sort('payment_amount')">PAYMENT AMOUNT <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                    <th class="sortable" (click)="sort('payment_date')">PAYMENT DATE <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of PaymentsList; let i = index;">
                                    <td>{{i+1}}</td>
                                    <td>{{item?.bank_name}}</td>
                                    <td>{{item?.finterstal_id}}</td>
                                    <td>{{item?.creator_name}}</td>
                                    <td>{{item?.customer_name}}</td>
                                    <td>{{item?.customer?.passport_no}}</td>
                                    <td>{{item?.customer?.cif}}</td>
                                    <td>{{item?.customer.acc_no}}</td>
                                    <td>{{item?.payment_amount | number: '2.'}}</td>
                                    <td>{{item?.payment_date | date}}</td>

                                </tr>
                            </tbody>
                        </table>
                        <div class="row">
                            <div class="col-md-6">
                                <button (click)="prevpay()">Previous</button>
                            </div>
                            <div class="col-md-6">
                                <button style="float: right;" (click)="nextpay()">Next</button>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Settlement Reports">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportSettlementreport()">EXPORT</button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-2">
                                <label>Start Date</label>
                            <input type="date" class="form-control"  [(ngModel)]="payment_start_date">
                            </div>
                            <div class="col-md-2">
                                <label>End Date</label>
                                <input type="date" class="form-control"  [(ngModel)]="payment_end_date">
                            </div>
                            <div class="col-md-2">
                                <label>Agent Name</label>
                                <select [(ngModel)]="agent_search" class="form-control" >
                                    <option *ngFor="let item of user_list" [value]="item.email_id">{{item.name}}</option>
                                </select>
                            </div>
                            <div  class="col-md-4">
                                <label>Action</label><br>
                                <button class="btn btn-sm btn-dark mb-1" (click)="SettlementRepSubSearch()">
                                    Search
                                </button>
                                <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="clear()">
                                    Clear
                                </button>
                            </div>
                        </div>
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">

                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <!-- <th>bank</th> -->
                                    <th>Team</th>
                                    <!-- <th>Manager</th>
                                    <th>Supervisor</th>
                                    <th>TL</th> -->
                                    <th>Agent</th>
                                    <th>CID</th>
                                    <th>customer name</th>
                                    <th>acc number</th>
                                    <th class="sortable" (click)="sort2('current_total')">SETTLEMENT AMOUNT  <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                    <th class="sortable" (click)="sort2('payment_date')">SETTLEMENT DATE  <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                    <th class="sortable" (click)="sort2('createdAt')">Logged Date and Time  <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of settlementList;let i =index">
                                    <td>{{i+1}}</td>
                                    <!-- <td>{{item?.bank_id?.bank_name}}</td> -->
                                    <td>{{item?.team_name}}</td>
                                    <!-- <td>{{item?.Member_user_id_Detail?.name}}</td>
                                    <td>{{item?.Reporting_to_id_Detail?.name}}</td>
                                    <td>{{item?.Reporting_to_id_Detail?.name}}</td> -->

                                    <td>{{item?.agent_name}}</td>
                                    <td>{{item?.cif}}</td>
                                    <td>{{item?.Customer_Name}}</td>
                                    <td>{{item?.customer_name?.acc_no}}</td>
                                    <td>{{item?.settlement_amount}}</td>
                                    <td>{{item?.settlement_date}}</td>
                                    <td>{{item?.createdAt}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>

                <mat-tab label="Settlements / Payments Reports">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportsettlementAndPaymentListreport()">EXPORT</button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-2">
                                <label>Start Date</label>
                            <input type="date" class="form-control"  [(ngModel)]="payment_start_date">
                            </div>
                            <div class="col-md-2">
                                <label>End Date</label>
                                <input type="date" class="form-control"  [(ngModel)]="payment_end_date">
                            </div>
                            <div class="col-md-2">
                                <label>Agent Name</label>
                                <select [(ngModel)]="payment_text_search" class="form-control" >
                                    <option *ngFor="let item of user_list" [value]="item.email_id">{{item.name}}</option>
                                </select>
                            </div>
                            <div  class="col-md-4">
                                <label>Action</label><br>
                                <button class="btn btn-sm btn-dark mb-1" (click)="SettlementPaymentListSearch()">
                                    Search
                                </button>
                                <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="clear()">
                                    Clear
                                </button>
                            </div>
                        </div>


                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <!-- <th>bank</th> -->
                                    <th>Team</th>
                                    <!-- <th>Manager</th>
                                    <th>Supervisor</th>
                                    <th>TL</th> -->
                                    <th>Agent</th>
                                    <th>CID</th>
                                    <th>customer name</th>
                                    <th>acc number</th>
                                    <th class="sortable" (click)="sort1('current_total')">PAYMENT AMOUNT <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                    <th class="sortable" (click)="sort1('payment_date')">PAYMENT DATE <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                    <th class="sortable" (click)="sort1('createdAt')">Logged Date and Time <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of settlementAndPaymentList;let i =index">
                                    <td>{{i+1}}</td>
                                    <!-- <td>{{item?.bank_id?.bank_name}}</td> -->
                                    <td>{{item?.team_name}}</td>
                                    <!-- <td>{{item?.Member_user_id_Detail?.name}}</td>
                                    <td>{{item?.Reporting_to_id_Detail?.name}}</td>
                                    <td>{{item?.Reporting_to_id_Detail?.name}}</td> -->

                                    <td>{{item?.agent_name}}</td>
                                    <td>{{item?.cif}}</td>
                                    <td>{{item?.Customer_Name}}</td>
                                    <td>{{item?.customer_name?.acc_no}}</td>
                                    <td>{{item?.current_total}}</td>
                                    <td>{{item?.payment_date}}</td>
                                    <td>{{item?.createdAt}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>

                <mat-tab label="Total Feedback Report">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportCustumDtailsreport()">EXPORT</button>
                            </div>
                        </div>
                         <div class="row">
                            <div class="col-md-2">
                                <label>Start Date</label>
                            <input type="date" class="form-control" placeholder="Text Search" [(ngModel)]="ptp_start_date">
                            </div>
                            <div class="col-md-2">
                                <label>End Date</label>
                            <input type="date" class="form-control" placeholder="Text Search" [(ngModel)]="ptp_end_date">
                            </div>
                            <div class="col-md-2">
                                <label>Select Agent</label>
                                <select [(ngModel)]="agent_search" class="form-control" >
                                    <option *ngFor="let item of user_list" [value]="item.email_id">{{item.name}}</option>
                                </select>
                            </div>
                            <div  class="col-md-4">
                                <label>Action</label><br>
                                <button class="btn btn-sm btn-dark mb-1" (click)=" filterFeedback()">
                                    Search
                                </button>
                                <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="clear()">
                                    Clear
                                </button>
                            </div>
                        </div>

                       <!-- {{FollowUpList |json}} -->
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Bank Name</th>
                                    <th>Agent Name</th>
                                    <th>Portfolio Name</th>
                                    <th>Fint ID</th>
                                    <th>Customer Name</th>
                                    <th >Passport No</th>
                                    <th>CID</th>
                                    <th>Acc No</th>
                                    <th>mstatus</th>
                                    <th >Total Feedback </th>
                                    <th class="sortable" (click)="sort8('updatedAt')">Logged Date <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of CustumDtails ; let i = index;">
                                    <td>{{i+1}}</td>
                                    <td>{{item?.bank_name}}</td>
                                    <td>{{item?.agent_name}}</td>
                                    <td>{{item?.portfolio_type}}</td>
                                    <td>{{item?.finterstal_id}}</td>
                                    <td>{{item?.customer_name}}</td>
                                    <td>{{item?.passport_no}}</td>
                                    <td>{{item?.cif}}</td>
                                    <td>{{item?.acc_no}}</td>
                                    <td>
                                        <tr *ngFor="let val of sortRemarksByDate(item.mstatus); let i = index">
                                            <td>{{i+1}} - {{val.mstatus}}</td>
                                            </tr>
                                    </td>
                                    <!-- <ng-container *ngFor="">
                                    <td>{{item?.remarks}}</td>
                                </ng-container> -->

                                <td>
                                  <tr *ngFor="let val of sortRemarksByDate(item.remarks); let i = index">
                                    <td>{{ i+1 }} - {{ val.remarks }} - {{ getFormattedDate(val.createdAt) }}</td>
                                  </tr>
                                </td>
                                <!-- <td>{{item?.remark}}</td> -->
                                        <td>{{item.Log_dateString}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>

                <mat-tab label="Total Allocation Report">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportReport_CustDetialsreport()">EXPORT</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2">
                                <label>Start Date</label>
                            <input type="date" class="form-control" placeholder="Text Search" [(ngModel)]="ptp_start_date">
                            </div>
                            <div class="col-md-2">
                                <label>End Date</label>
                            <input type="date" class="form-control" placeholder="Text Search" [(ngModel)]="ptp_end_date">
                            </div>
                            <div class="col-md-2">
                                <label>Select Agent</label>
                                <select [(ngModel)]="agent_search" class="form-control" >
                                    <option *ngFor="let item of user_list" [value]="item.email_id">{{item.name}}</option>
                                </select>
                            </div>
                            <div  class="col-md-4">
                                <label>Action</label><br>
                                <button class="btn btn-sm btn-dark mb-1" (click)="filterAllocation()">
                                    Search
                                </button>
                                <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="clear()">
                                    Clear
                                </button>
                            </div>
                        </div>
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Bank Name</th>
                                    <th>Agent Name</th>
                                    <th>Portfolio Name</th>
                                    <th class="sortable" (click)="sort('finterstal_id')">Fint ID <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                    <th>Customer Name</th>
                                    <th>Passport No</th>
                                    <th>CID</th>
                                    <th>Acc No</th>
                                    <th class="sortable" (click)="sort('total_out_standing')">Total Outstanding <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                    <th  class="sortable" (click)="sort('date_of_allocations')">Allocation Date <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of Report_CustDetials ; let i = index;">
                                    <td>{{i+1}}</td>
                                    <td>{{item?.bank_name}}</td>
                                    <td>{{item?.agent_name}}</td>
                                    <td>{{item?.portfolio_type}}</td>
                                    <td>{{item?.finterstal_id}}</td>
                                    <td>{{item?.customer_name}}</td>
                                    <td>{{item?.passport_no}}</td>
                                    <td>{{item?.cif}}</td>
                                    <td>{{item?.acc_no}}</td>
                                    <td>{{item?.total_out_standing}}</td>
                                    <td>{{item?.date_of_allocations}}</td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>





                <mat-tab label="Field Visit Reports">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportFieldvisitreport()">EXPORT</button>
                            </div>
                        </div>

                          <div class="row">
                            <div class="col-md-2">
                                <label>Start Date</label>
                            <input type="date" class="form-control"  [(ngModel)]="payment_start_date">
                            </div>
                            <div class="col-md-2">
                                <label>End Date</label>
                                <input type="date" class="form-control"  [(ngModel)]="payment_end_date">
                            </div>
                            <div class="col-md-2">
                                <label>Agent Name</label>
                                <select [(ngModel)]="payment_text_search" class="form-control" >
                                    <option *ngFor="let item of user_list" [value]="item.email_id">{{item.name}}</option>
                                </select>
                            </div>
                            <div  class="col-md-4">
                                <label>Action</label><br>
                                <button class="btn btn-sm btn-dark mb-1" (click)="fieldVisitRReportSearch()">
                                    Search
                                </button>
                                <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="clear()">
                                    Clear
                                </button>
                            </div>
                        </div>

                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm  table-hover" *ngIf="!show_loader"  >
                             <thead>
                                <tr>
                                    <th>S.No</th>
                                    <!-- <th>bank</th>
                                    <th>Team</th>
                                    <th>Manager</th>
                                    <th>Supervisor</th>
                                    <th>TL</th> -->
                                    <th >Agent</th>
                                    <th>customer name</th>
                                    <th>acc number</th>
                                    <th class="sortable" (click)="sort('approval_status')">FIELD VIST STATUS <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                    <th class="sortable" (click)="sort('fvrqdate')">FIELD VIST DATE <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                    <th class="sortable" (click)="sort('fvrqdate')">Logged Date and Time <i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of fieldVisitReportList;let i =index">
                                    <td>{{i+1}}</td>
                                    <!-- <td>{{item?.bank_name}}</td>
                                    <td>{{item?.reportingtoDetail?.team_name}}</td>
                                    <td>{{item?.Member_user_id_Detail?.name}}</td>
                                    <td>{{item?.Reporting_to_id_Detail?.name}}</td>
                                    <td>{{item?.Reporting_to_id_Detail?.name}}</td> -->

                                    <td>{{item?.agent_name}}</td>
                                    <td>{{item?.Customer_Name}}</td>
                                    <td>{{item?.customer_name?.acc_no}}</td>
                                    <td>{{item?.approval_status}}</td>
                                    <td>{{item?.fvrqdate}}</td>
                                    <td>{{item?.fvrqdate}}</td>
                                </tr>


                            </tbody>
                        </table>
                    </div>
                </mat-tab>


                <mat-tab label="Short Base Report">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportshortBaseReportListreport()">EXPORT</button>
                            </div>
                        </div>

                          <div class="row">
                            <div class="col-md-2">
                                <label>Start Date</label>
                            <input type="date" class="form-control"  [(ngModel)]="payment_start_date">
                            </div>
                            <div class="col-md-2">
                                <label>End Date</label>
                                <input type="date" class="form-control"  [(ngModel)]="payment_end_date">
                            </div>
                            <div class="col-md-2">
                                <label>Agent Name</label>
                                <select [(ngModel)]="payment_text_search" class="form-control" >
                                    <option *ngFor="let item of user_list" [value]="item.email_id">{{item.name}}</option>
                                </select>
                            </div>
                            <div  class="col-md-4">
                                <label>Action</label><br>
                                <button class="btn btn-sm btn-dark mb-1" (click)="shortBaseReportSearch()">
                                    Search
                                </button>
                                <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="clear()">
                                    Clear
                                </button>
                            </div>
                        </div>

                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>bank</th>
                                    <!-- <th>Product</th>
                                    <th>CIF</th> -->
                                    <th>CID</th>
                                    <th>AC No</th>
                                    <th>Name</th>
                                    <th>TOS</th>
                                    <!-- <th>POS</th>
                                    <th>CL</th> -->
                                    <th>Nationality</th>
                                    <th>Passport</th>
                                    <th>Emirates Id</th>
                                    <!-- <th>Manual Emirates Id</th> -->
                                    <th>Email Id</th>
                                    <th>Agency Allocation Date</th>
                                    <th >Current date</th>
                                    <th>Status</th>
                                    <th>SubStatus</th>
                                    <th class="sortable" (click)="sort3('fvrqdate')" >Follow Up Date<i class="fa fa-fw fa-sort" [ngClass]="{'sort-asc': sortField === 'name' && sortOrder === 'asc', 'sort-desc': sortField === 'name' && sortOrder === 'desc'}"></i></th>

                                    <!-- <th>Limited Remark Remark</th>
                                    <th>Dual Allocation Agent Name</th> -->



                            </thead>
                            <tbody>

                                <tr *ngFor="let item of shortBaseReportList;let i=index">
                                    <td>{{i+1}}</td>
                                    <td>{{item?.bank_name}}</td>
                                    <!-- <td>{{item?.portfolio_typesDetail.portfolio_type}}</td> -->
                                    <!-- <td></td>
                                    <td>{{item.cust && item.cust[0] && item.cust[0].cif ? item.cust[0].cif : item.customer_details[0]?.cif }}</td> -->


                                    <td>{{item?.cif}}</td>
                                    <td>{{item?.acc_no}}</td>
                                    <td>{{item?.customer_name }}</td>
                                    <td>{{item?.total_out_standing}}</td>
                                    <!-- <td></td>
                                    <td></td>
                                    <td></td> -->
                                    <td>{{item?.nationality}}</td>
                                    <td>{{item?.passport_no }}</td>
                                    <td>{{item?.emirates_id }}</td>
                                    <td>{{item?.email_id}}</td>

                                    <td>{{item?.date_of_allocations}}</td>
                                    <td>{{item?.added_at}}</td>
                                    <td>{{item?.status}}</td>
                                    <td></td>
                                    <td></td>
                                    <!-- <td>{{item?.added_at}}</td>
                                    <td>{{item.cust && item.cust[0] && item.cust[0].AGENT ? item.cust[0].AGENT : item.customer_details[0]?.AGENT }}</td> -->

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>



                <mat-tab label="Base Report Bank">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportbaseReportBankListreport()">EXPORT</button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-2">
                                <label>Start Date</label>
                            <input type="date" class="form-control"  [(ngModel)]="payment_start_date">
                            </div>
                            <div class="col-md-2">
                                <label>End Date</label>
                                <input type="date" class="form-control"  [(ngModel)]="payment_end_date">
                            </div>
                            <div class="col-md-2">
                                <label>Agent Name</label>
                                <select [(ngModel)]="payment_text_search" class="form-control" >
                                    <option *ngFor="let item of user_list" [value]="item.email_id">{{item.name}}</option>
                                </select>
                            </div>
                            <div  class="col-md-4">
                                <label>Action</label><br>
                                <button class="btn btn-sm btn-dark mb-1" (click)="baseReportBankSearch()">
                                    Search
                                </button>
                                <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="clear()">
                                    Clear
                                </button>
                            </div>
                        </div>

                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm scroll" *ngIf="!show_loader">                            <thead>
                                <tr>



                                    <th>S.No</th>
                                    <th>bank</th>
                                    <th>Portfolio Name</th>
                                    <!-- <th>CIF</th> -->
                                    <th>CID</th>
                                    <th>AC No</th>
                                    <th>Name</th>
                                    <th>TOS</th>
                                    <!-- <th>POS</th> -->
                                    <th>Passport</th>
                                    <th>Emirates Id</th>
                                    <!-- <th>Manual Emirates Id</th> -->
                                    <!-- <th></th> -->
                                    <th>Current Date</th>
                                    <!-- <th>Bank Code</th> -->
                                    <th>Status</th>
                                    <th>SubStatus</th>
                                    <th>Follow Up Date</th>
                                    <th>Remark</th>
                                    <!-- <th>One Liner Remark</th> -->
                                    <th>Agent Name</th>
                                    <!-- <th>TL Name</th>
                                    <th>Supervisor Name</th>
                                    <th>Manager Name</th>
                                    <th>Dual Allocation Agent Name</th> -->



                            </thead>
                            <tbody>




                                <tr *ngFor="let item of baseReportBankList;let i=index">
                                    <td>{{i+1}}</td>
                                    <td>{{item?.BankDetail?.bank_name}}</td>
                                    <td>{{item?.portfolio_typesDetail.portfolio_type}}</td>
                                    <!-- <td></td> -->
                                    <td>{{item?.cif}}</td>
                                    <!-- <td></td> -->
                                    <td>{{item?.acc_no}}</td>
                                <td>{{item?.customer_name }}</td>
                                <td>{{item?.total_out_standing}}</td>
                                    <!-- <td></td> -->

                                <td>{{item?.passport_no }}</td>
                                <td>{{item?.emirates_id }}</td>
                                    <!-- <td></td>   -->
                                    <!-- <td>{{item.cust && item?.cust[0]?.Email_ID}}</td>  -->
                                    <!-- <td></td> -->
                                    <td>{{item?.added_at}}</td>
                                    <!-- <td></td> -->
                                    <td>{{item?.status}}</td>
                                    <td></td>
                                    <td>{{item?.added_at}}</td>
                                    <td></td>
                                    <!-- <td></td> -->
                                    <td>{{item?.agent_name}}</td>
                                    <!-- <td></td>
                                    <td></td>
                                    <td></td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>


                <!-- <mat-tab label="Account Status Movement Report">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportFieldvisitreport()">EXPORT</button>
                            </div>
                        </div>
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>bank</th>
                                    <th>Product</th>
                                    <th>CIF</th>
                                    <th>CID</th>
                                    <th>AC No</th>
                                    <th>Name</th>
                                    <th>TOS</th>
                                    <th>POS</th>
                                    <th>Passport</th>
                                    <th>Emirates Id</th>
                                    <th>Manual Emirates Id</th>
                                    <th>Jan-20 Agent</th>
                                    <th>Last Log Date of the Jan-20</th>
                                    <th>Jan-20 Status</th>
                                    <th>Jan-20 Sub Status</th>
                                    <th>Jan-20 Remark Only</th>
                                    <th>Feb-20 Agent</th>
                                    <th>Last Log Date of the Feb-20</th>
                                    <th>Feb-20 Status</th>
                                    <th>Feb-20 Sub Status</th>
                                    <th>Feb-20 Remark Only</th>
                                    <th>And so on for the range of months selected</th>



                            </thead>
                            <tbody>
                                <tr *ngFor="let item of FieldvisitList">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>

                <mat-tab label="Allocation Change Tracker">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportFieldvisitreport()">EXPORT</button>
                            </div>
                        </div>
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>bank</th>
                                    <th>Product</th>
                                    <th>CIF</th>
                                    <th>CID</th>
                                    <th>AC No</th>
                                    <th>Name</th>
                                    <th>TOS</th>
                                    <th>POS</th>
                                    <th>Passport</th>
                                    <th>Emirates Id</th>
                                    <th>Manual Emirates Id</th>
                                    <th>Allocation Period</th>
                                    <th>Agent 1</th>
                                    <th>Allocation Period</th>
                                    <th>Agent 2</th>
                                    <th>Allocation Period</th>
                                    <th>Agent 3</th>
                                    <th>Allocation Period</th>
                                    <th>Agent 4</th>
                                    <th>Allocation Period</th>
                                    <th>Agent 5</th>


                            </thead>
                            <tbody>
                                <tr *ngFor="let item of FieldvisitList">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>

                <mat-tab label="MTS Detail Report">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportFieldvisitreport()">EXPORT</button>
                            </div>
                        </div>
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>bank</th>
                                    <th>Product</th>
                                    <th>CIF</th>
                                    <th>CID</th>
                                    <th>AC No</th>
                                    <th>Name</th>
                                    <th>TOS</th>
                                    <th>POS</th>
                                    <th>CL</th>
                                    <th>Passport #</th>
                                    <th>Settlement Type</th>
                                    <th>Settlement Amount</th>
                                    <th>No.of Instalment</th>
                                    <th>Start Date</th>
                                    <th>end Date</th>
                                    <th>Paid Till Date</th>
                                    <th>Invoive Till Date</th>
                                    <th>Agent</th>
                                    <th>Settlement Remarks</th>
                                    <th>Jan-20</th>
                                    <th>Feb-20</th>
                                    <th>Mar-20</th>
                                    <th>Apr-20</th>
                                    <th>May-20</th>
                                    <th>Jun-20</th>
                                    <th>Jul-20</th>
                                    <th>Aug-20</th>
                                    <th>Sep-20</th>
                                    <th>Oct-20</th>
                                    <th>Nov-20</th>
                                    <th>Dec-20</th>
                                    <th>Jan-21</th>
                                    <th>Feb-21</th>
                                    <th>Mar-21</th>
                                    <th>Apr-21</th>
                                    <th>May-21</th>
                                    <th>Jun-21</th>
                                    <th>Jul-21</th>
                                    <th>Aug-21</th>
                                    <th>Sep-21</th>
                                    <th>Oct-21</th>
                                    <th>Nov-21</th>



                            </thead>
                            <tbody>
                                <tr *ngFor="let item of FieldvisitList">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab> -->
<!--
                <mat-tab label="Paid history">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportFieldvisitreport()">EXPORT</button>
                            </div>
                        </div>
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>bank</th>
                                    <th>Product</th>
                                    <th>CIF</th>
                                    <th>CID</th>
                                    <th>AC No</th>
                                    <th>Name</th>
                                    <th>TOS</th>
                                    <th>POS</th>
                                    <th>CL</th>
                                    <th>Passport #</th>
                                    <th>Agent</th>
                                    <th>Status</th>
                                    <th>SubStatus</th>
                                    <th>Paid Amount</th>
                                    <th>Invoice Amount</th>


                            </thead>
                            <tbody>
                                <tr *ngFor="let item of FieldvisitList">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>-->

                <mat-tab label="Portfolio Wise - Status Report">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportFieldvisitreport()">EXPORT</button>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-md-2">
                                <label>Start Date</label>
                            <input type="date" class="form-control"  [(ngModel)]="payment_start_date">
                            </div>
                            <div class="col-md-2">
                                <label>End Date</label>
                                <input type="date" class="form-control"  [(ngModel)]="payment_end_date">
                            </div>
                            <div class="col-md-2">
                                <label>Agent Name</label>
                                <select [(ngModel)]="payment_text_search" class="form-control" >
                                    <option *ngFor="let item of user_list" [value]="item.name">{{item.name}}</option>
                                </select>
                            </div>
                            <div  class="col-md-4">
                                <label>Action</label><br>
                                <button class="btn btn-sm btn-dark mb-1" (click)="SettlementRepSubSearch()">
                                    Search
                                </button>
                                <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="SettlementClear()">
                                    Clear
                                </button>
                            </div>
                        </div>
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Bank</th>
                                    <th>Work Status</th>
                                    <th>Status</th>
                                    <th>No.of Accounts</th>



                            </thead>
                            <tbody>
                                <tr *ngFor="let item of FieldvisitList">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>

                            </tbody>
                        </table>
                    </div>
                </mat-tab>

                <mat-tab label="Portfolio Wise - Status Report Full">





                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportFieldvisitreport()">EXPORT</button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-2">
                                <label>Start Date</label>
                            <input type="date" class="form-control"  [(ngModel)]="payment_start_date">
                            </div>
                            <div class="col-md-2">
                                <label>End Date</label>
                                <input type="date" class="form-control"  [(ngModel)]="payment_end_date">
                            </div>
                            <div class="col-md-2">
                                <label>Agent Name</label>
                                <select [(ngModel)]="payment_text_search" class="form-control" >
                                    <option *ngFor="let item of user_list" [value]="item.name">{{item.name}}</option>
                                </select>
                            </div>
                            <div  class="col-md-4">
                                <label>Action</label><br>
                                <button class="btn btn-sm btn-dark mb-1" (click)="SettlementRepSubSearch()">
                                    Search
                                </button>
                                <button style="margin-left: 10px;" class="btn btn-sm btn-dark mb-1" (click)="SettlementClear()">
                                    Clear
                                </button>
                            </div>
                        </div>
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Bank</th>
                                    <th>Work Status</th>
                                    <th>Status</th>
                                    <th>No.of Accounts</th>



                            </thead>
                            <tbody>
                                <tr *ngFor="let item of FieldvisitList">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>

                            </tbody>
                        </table>
                    </div>
                </mat-tab>
<!--
               <mat-tab label="Dual Allocation - Full Report">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportFieldvisitreport()">EXPORT</button>
                            </div>
                        </div>
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>bank</th>
                                    <th>Product</th>
                                    <th>CIF</th>
                                    <th>CID</th>
                                    <th>AC No</th>
                                    <th>Name</th>
                                    <th>TOS</th>
                                    <th>POS</th>
                                    <th>CL</th>
                                    <th>Passport #</th>
                                    <th>Agency Allocation Date</th>
                                    <th>Agent Allocation Date</th>
                                    <th>Agent 1</th>
                                    <th>Status when Allocated</th>
                                    <th>Substatus when Allocated</th>
                                    <th>Dual Allocation Date</th>
                                    <th>Dual Agent</th>
                                    <th>exit Date-Dual</th>



                            </thead>
                            <tbody>
                                <tr *ngFor="let item of FieldvisitList">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>

               <-- <mat-tab label="Dual Agent Update Report">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportFieldvisitreport()">EXPORT</button>
                            </div>
                        </div>
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Bank</th>
                                    <th>Product</th>
                                    <th>CIF</th>
                                    <th>CID</th>
                                    <th>AC No</th>
                                    <th>Name</th>
                                    <th>TOS</th>
                                    <th>POS</th>
                                    <th>CL</th>
                                    <th>Passport #</th>
                                    <th>Agent 1</th>
                                    <th>Dual Allocation Date</th>
                                    <th>Dual Agent</th>
                                    <th>Current Date</th>
                                    <th>Status</th>
                                    <th>Substatus</th>
                                    <th>Follow Up Date</th>
                                    <th>Remark </th>
                                    <th>Last Updated - Agent(agent1/Dual Agent)</th>



                            </thead>
                            <tbody>
                                <tr *ngFor="let item of FieldvisitList">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>

                <mat-tab label="Invoice Report">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportFieldvisitreport()">EXPORT</button>
                            </div>
                        </div>
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Bank</th>
                                    <th>Product</th>
                                    <th>CIF</th>
                                    <th>CID</th>
                                    <th>AC No</th>
                                    <th>Name</th>
                                    <th>Passport Number</th>
                                    <th>Emirates Id</th>
                                    <th>Manual EID</th>
                                    <th>Invoiced Amount</th>
                                    <th>Invoice Date/Month</th>
                                    <th>Payment Collected by - Agent</th>
                                    <th>PCB - TL</th>
                                    <th>PCB - Supervisor</th>
                                    <th>PCB -  Manager</th>



                            </thead>
                            <tbody>
                                <tr *ngFor="let item of FieldvisitList">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>

                <mat-tab label="Account Wise Agent Movement Report">
                    <div class="card" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-end">
                                <button class="btn btn-sm btn-dark mb-1" (click)="exportFieldvisitreport()">EXPORT</button>
                            </div>
                        </div>
                        <div class="loader" *ngIf="show_loader"></div>
                        <table class="table table-bordered table-sm" *ngIf="!show_loader">                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>bank</th>
                                    <th>Product</th>
                                    <th>CIF</th>
                                    <th>CID</th>
                                    <th>AC No</th>
                                    <th>Cm Name</th>
                                    <th>Passport Number</th>
                                    <th>Emirates Id</th>
                                    <th>Manual Emirates Id</th>
                                    <th>Jan-20</th>
                                    <th>Feb-20</th>
                                    <th>Mar-20</th>
                                    <th>Apr-20</th>
                                    <th>May-20</th>
                                    <th>Jun-20</th>
                                    <th>Jul-20</th>
                                    <th>Aug-20</th>
                                    <th>Sep-20</th>
                                    <th>Oct-20</th>
                                    <th>Nov-20</th>
                                    <th>Dec-20</th>
                                    <th>Jan-21</th>
                                    <th>Feb-21</th>
                                    <th>Mar-21</th>
                                    <th>Apr-21</th>
                                    <th>May-21</th>
                                    <th>Jun-21</th>


                            </thead>
                            <tbody>
                                <tr *ngFor="let item of FieldvisitList">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab> -->

            </mat-tab-group>
        </div>
    </div>
</div>
